import React, { Component } from 'react';
import { Container, Row, Col ,Spinner,Button} from 'react-bootstrap';
import RestServices from '../services/RestServices.js';
import Alert from 'react-bootstrap/Alert';

import * as ROUTES from '../../constants/routes';
import { NavLink } from 'react-router-dom';
import './signin.css';
import queryString from 'query-string';
import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
class DepositeConfirmation extends Component {
    _isMounted = false;
    _isMounted = false;

    state = {
        alert: 0,
        alertMessage: '',
        flag: 0,
        link_url:'',
        loading:true,
    };
    constructor(props) {
        super(props);
    }

    async componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        let link_id = queryString.parse(this.props.location.search).link_id;// Cashfree link Depost
        let order_id = queryString.parse(this.props.location.search).order_id; // Cashfree direct Depost
        let razorpay_payment_link_id = queryString.parse(this.props.location.search).razorpay_payment_link_id; // razorpay link Deposit
        if(order_id){
            this.getOrderStatus(order_id);
        }else if (link_id) {
           this.getCashFreeLinkStatus(link_id);
        }else if(razorpay_payment_link_id){
         this.getRazorPayLinkStatus(razorpay_payment_link_id);
        }else{
            this.setState({
                loading:false,
                alert: 2,
                alertMessage: 'Oops invalid request...'
            });
        }
     }
    

    async getRazorPayLinkStatus(linkId) {
        let bodyData = {
            linkId: linkId
        };
        await RestServices.getRazorPayLinkStatus(bodyData)
            .then((response) => response.json())
            .then(async (responseData) => {
                if(responseData.short_url){
                if (this._isMounted) {
                    this.setState({
                        link_url:responseData.short_url,
                        loading:false,
                        alert: 2,
                        alertMessage: 'Thank you for the payment...'
                    });
                }
            }else{
                this.setState({
                    loading:false,
                    alert: 1,
                    alertMessage: responseData.error.description
                });
            }
             });
      }


    async getCashFreeLinkStatus(linkId) {
        let bodyData = {
            linkId: linkId
        };
        await RestServices.getCashFreeLinkStatus(bodyData)
            .then((response) => response.json())
            .then(async (responseData) => {
                if (this._isMounted) {
                    this.setState({
                        link_url:responseData.link_url,
                        loading:false,
                        alert: 2,
                        alertMessage: 'Thank you for the payment...'
                    });
                }
            });

 }

    async getOrderStatus(orderId) {
        let bodyData = {
            orderId: orderId
        };
        await RestServices.getOrderStatus(
            bodyData
        )
            .then((response) => response.json())
            .then(async (responseData) => {
			if (this._isMounted) {
                    this.setState({
                        loading:false,
                        alert: 5,
                        alertMessage: 'Thank you for the payment...'
                    });
                    
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: 2,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }
 
reLoadPaymentLink = () => {
    window.location.href = this.state.link_url;
}
    render() {
        return (
            <Container>

                <Row>
                    <Col md={{ span: 4, offset: 4 }}>
                        <h3 align="center">Payment Confirmation</h3>
                        {this.state.loading && <Spinner animation="border" />}

                        {this.state.loading && <Row>
                                <Col>
                                    <Alert variant="danger">
                                        Please do not close or reload this window.
                                    </Alert>
                                </Col>
                      </Row>}

                        {this.state.alert === 1 && (
                            <Row>
                                <Col>
                                    <Alert variant="danger">
                                        {this.state.alertMessage}
                                    </Alert>
                                </Col>
                            </Row>
                        )}
                        {this.state.alert === 5 && (
                            <Row>
                                <Col>
                                    <Alert variant="success">
                                        {this.state.alertMessage}
                                        <div align="right" style={{ marginTop: '1rem'}}>
                                        <NavLink exact to={ROUTES.TransactionHistory} style={{ paddingLeft: '1rem',paddingRight: '1rem' }} variant="primary" >
                                            View Transaction
                                        </NavLink>
                                        </div> 
                                    </Alert>
                                </Col>
                            </Row>
                        )}  
                        {this.state.alert === 2 && (
                            <Row>
                                <Col>
                                    <Alert variant="success">
                                        {this.state.alertMessage}
                                        <p>Do you want to make another payment?</p>
                                        <div align="right" style={{ marginTop: '1rem'}}>
                                        <Button style={{ paddingLeft: '1rem',paddingRight: '1rem' ,marginRight: '1rem' }} variant="primary" onClick={this.reLoadPaymentLink}>
                                        Yes
                                        </Button>
                                        <NavLink exact to={ROUTES.TransactionHistory} style={{ paddingLeft: '1rem',paddingRight: '1rem' }} variant="primary" >
                                            View Transaction
                                        </NavLink>
                                        </div>   
                                    </Alert>
                                </Col>
                            </Row>
                        )}
                    </Col>
                </Row>

                
            </Container>
        );
    }
}

export default DepositeConfirmation;
